<template>
    <div>
        <div class="nolist" v-show="!hasmsg">
            <img src="@/assets/nomsg.png" alt="">
            没有任何订单
            <p @click="loads">刷新</p>
        </div>
        <div class="isloginTips" v-show="loadingShow">
            <img src="@/assets/loading.png" alt="">
            <p>数据加载中...</p>
        </div>
        <div v-show="hasmsg">
            <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit" >
                <div ref="directrecordwp">
                <div class="list" v-for="(item,index) of dataList" :key="index">
                    <div class="list-item">
                        <div class="water-mark" v-show="mnwatermark">模拟</div>
                        <div class="title">
                            <span :style="{backgroundColor:item.orderDirection == 0 || item.orderDirection == 2 || item.orderDirection == 4 || item.orderDirection == 6?'#FF4F36':(item.orderDirection == 1 || item.orderDirection == 3 || item.orderDirection == 5 || item.orderDirection == 7?'#17CF84':'#FF4F36')}">{{item.orderDirection == 0?'买入':(item.orderDirection == 1?'卖出':(item.orderDirection == 2?'限价买入':(item.orderDirection == 3?'限价卖出':(item.orderDirection==4?'止损买入':(item.orderDirection == 5?'止损卖出':(item.orderDirection == 6?'停价止损买入':(item.orderDirection == 7?'停价止损卖出':'')))))))}}</span>
                            <span>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?'伦敦金':(item.symbol == 'XAG' || item.symbol == 'SILVER'?'伦敦银':'未知')}}</span>
                            <span>{{item.lots.toFixed(2)+'手'}}</span>
                        </div>
                        <ul>
                            <li>
                                <div class="left">
                                    <p>订单号<span>{{item.ticket}}</span></p>
                                    <p>挂单价<span>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?item.openPrice.toFixed(2):(item.symbol == 'XAG' || item.symbol == 'SILVER'?item.openPrice.toFixed(3):item.openPrice.toFixed(2))}}</span></p>
                                    <p>挂单<span>{{getTime(item.openTime,'y')}}</span></p>
                                </div>
                                <div class="right">
                                    <p>止损<span>{{item.stopLoss && item.symbol == 'XAU' || item.symbol == 'GOLD'?item.stopLoss.toFixed(2):(item.stopLoss && item.symbol == 'XAG' || item.symbol == 'SILVER'?item.stopLoss.toFixed(3):"未设置")}}</span></p>
                                    <p>止盈<span>{{item.takeProfit && item.symbol == 'XAU' || item.symbol == 'GOLD'?item.takeProfit.toFixed(2):(item.takeProfit && item.symbol == 'XAG' || item.symbol == 'SILVER'?item.takeProfit.toFixed(3):"未设置")}}</span></p>
                                    <p>失效<span>{{getTime(item.closeTime,'y')}}</span></p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                </div>
            </mescroll-vue>
        </div>
    </div>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import Watermark from '@/utils/watermark'
import pako from 'pako'
import {allcdhistory,utf8ByteToUnicodeStr} from '@/utils/socket2.js';
import moment from 'moment'
export default {
    inject:['reload'], //注入刷新当前页依赖 来自app.vue
    name:'shixiaos',
    props:{
        datetext:{
            type:String
        },
        changetimestart:{
            type:String  
        },
        changetimeend:{
            type:String
        },
        ordertext:{
            type:String
        },
    },
    components: {
		MescrollVue // 注册mescroll组件
	},
    data(){
        return{
            mnwatermark:false,//水印
            loadingShow:false,
            hasmsg:false,//有无订单

            pcstarttime:null,
            pcendtime:null,
            pcflag:null,

            page:0,//初始页数
            number:10,//每次加载条数
            initarr:[],

            mescroll: null, // mescroll实例对象
			mescrollDown:{
                auto:false,
                callback:this.downCallback
            }, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
			mescrollUp: { // 上拉加载的配置.
                auto:false,
			    callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
			    //以下是一些常用的配置,当然不写也可以的.
                 page: {
                    num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
                    size: 10 //每页数据条数,默认10
                },
                htmlNodata: '<p class="upwarp-nodata">-- 没有更多数据了 --</p>',
                noMoreSize: 5, //如果列表已无数据,可设置列表的总数量要大于5才显示无更多数据;
                            // 避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
                            // 这就是为什么无更多数据有时候不显示的原因
                empty: {
                    //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
                    warpId: "xxid", //父布局的id (1.3.5版本支持传入dom元素)
                    icon: "./static/mescroll/mescroll-empty.png", //图标,默认null,支持网络图
                    tip: "暂无相关数据~" //提示
                }
			},
			dataList: [] // 列表数据
        }
    },

    methods:{

        // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},

        // 开启websocket
        initWebpack(){

            var that = this

            if (that.global.ws && that.global.ws.readyState == 1) {

                this.loadingShow = true //开启加载提示



                if(this.datetext == null){
                    
                    let startDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'); //今天开始时间
                    let endDate =  moment().endOf('day').format('YYYY-MM-DD HH:mm:ss') //今天结束时间
                    
                    allcdhistory(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端
                }else if(this.datetext == '今日'){

                    let startDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'); //今天开始时间
                    let endDate =  moment().endOf('day').format('YYYY-MM-DD HH:mm:ss') //今天结束时间
                    
                    allcdhistory(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端
                }else if(this.datetext == '昨日'){

                    let startDate =  moment(moment().add(-1, 'days').startOf("day").valueOf()).format("YYYY-MM-DD HH:mm:ss"); //昨日开始时间
                    let endDate =  moment(moment().add(-1, 'days').endOf('day').valueOf()).format('YYYY-MM-DD HH:mm:ss'); //昨日结束时间
                    
                    allcdhistory(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端
                }else if(this.datetext == '最近七日'){
                    // 最近七日
                    let startDate = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)-7*3600*24*1000
                    let endDate =  new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1); //今天结束时间
                    
                    allcdhistory(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端
                }else if(this.datetext == '最近一个月'){
                    // 最近一个月
                    let startDate = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)-30*3600*24*1000
                    let endDate =  new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1); //今天结束时间
                    
                    allcdhistory(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端
                }else if(this.datetext == '最近三个月'){
                    // 最近三个月
                    let startDate = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)-90*3600*24*1000
                    let endDate =  new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1); //今天结束时间
                    
                    allcdhistory(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端
                }else if(this.datetext == '最近六个月'){
                    // 最近六个月
                    let startDate = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)-180*3600*24*1000
                    let endDate =  new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1); //今天结束时间
                    
                    allcdhistory(moment(startDate).format('X'),moment(endDate).format('X'),that.global.ws) // 发送信息给服务端
                }else if(this.datetext.indexOf('~')>-1){


                    var d = moment(new Date()).format('YYYY-MM-DD')

                    if(this.pcstarttime == null || this.pcstarttime == d){
                        this.pcstarttime = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');//今天开始时间
                    }

                    if(this.pcendtime == null || this.pcendtime == d){
                        this.pcendtime = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss') //今天结束时间
                    }

                    if(this.pcstarttime && this.pcendtime){

                        this.pcstarttime = this.datetext.replace(/~/g,'').slice(0,10)

                        this.pcendtime = this.datetext.replace(/~/g,'').slice(-10)

                        this.pcendtime = Number(moment(this.pcendtime).format('X')) + 86399
                        
                    }



                    let startDate = this.pcstarttime
                    let endDate = this.pcendtime



                    allcdhistory(moment(startDate).format('X'),endDate,that.global.ws) // 发送信息给服务端

                }
            
            

            that.global.ws.onmessage = this.onmessage


            }
        },

        onmessage(evt){
            var data = atob(evt.data);
            var data2 = pako.inflateRaw(data);
            var arr = new Uint16Array(data2);
            var strData   = utf8ByteToUnicodeStr(arr);
            var obj = JSON.parse(strData)

            if(obj.act == 'get_history_pend_orders' && obj.arr){

                obj.arr.sort(function(a, b) {
                    let aTimeString = a['closeTime']
                    let bTimeString = b['closeTime']
                    let aTime = new Date(aTimeString).getTime()
                    let bTime = new Date(bTimeString).getTime()
                    return bTime - aTime 
                });

                this.initarr = obj.arr //定义了初始initarr存储总条数
                this.dataList = this.initarr.slice(this.page,this.number) //每次加载赋予值得datalist先渲染10条
                this.hasmsg = true //是否有订单



                this.$toast('加载成功');

                this.mescroll.endSuccess(this.dataList.length,this.dataList.length < this.initarr.length ? true : false)

                this.$store.state.sxconfirm = false //关闭开关

                this.loadingShow = false //关闭加载提示
                
            }else if(obj.act == 'get_history_pend_orders' && !obj.arr){
                console.log('1')
                this.$toast(obj.msg)
                this.hasmsg = false //是否有订单
                this.$store.state.sxconfirm = false //关闭开关
                this.loadingShow = false //关闭加载提示
            }

            // 全局订单推送
            if(obj.act == 'order_update'){

                if(this.$store.state.login){

                    this.$store.state.ordertipshow = true

                    this.$store.state.ordertype = obj.msg.replace(/[0-9]/g,"")

    
                    this.$store.state.orderticket = obj.msg.replace(/[^\d.]/g,"");
                    this.$store.state.ordersymbol = obj.data.symbol
                    this.$store.state.orderdeal = obj.data.orderDirection
                    this.$store.state.orderopenprice = obj.data.openPrice
                    this.$store.state.ordercloseprice = obj.data.closePrice
                    this.$store.state.orderlots = obj.data.lots
                    this.$store.state.orderopentime = obj.data.openTime
                    this.$store.state.orderclosetime = obj.data.closeTime


                    setTimeout(() => {

                        this.$store.state.ordertipshow = false


                    }, 5000)
                }
            }
        },

        upCallback (page, mescroll) {



            const getlist = this.initarr.slice(this.dataList.length, this.dataList.length + 10)

            this.dataList = this.dataList.concat(getlist)

            this.$nextTick(() => {
                mescroll.endSuccess(getlist.length,this.dataList.length < this.initarr.length ? true : false)
            })


	    },

        downCallback (mescroll) {
            
            this.initWebpack()

	    },

        loads(){
            this.initWebpack()
        }
    },

    watch:{
        'datetext'(val){
            if(val){
                this.initWebpack()
            }

        },
        'changetimestart'(val){
            this.pcstarttime = val
        },
        'changetimeend'(val){
            this.pcendtime = val
        },
        'ordertext'(val){
            val = '失效挂单'
        }
    },

    mounted(){
        this.initWebpack()
        // 加水印
        if(this.$store.state.mnlogin){
            this.mnwatermark = true
        }else{
            this.mnwatermark = false
        }
        // 禁止浏览器自带返回
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', function () {
            history.pushState(null, null, document.URL);
        });

    }
}
</script>

<style scoped>
    body{touch-action: none;}
    li{list-style: none;}

    /* 水印 */
    .water-mark{color:rgba(200, 200, 200, 0.80);font-size: 30px;position: absolute;bottom: 50px;right: 75px;}

    .nolist{color: #999999;font-size:14px;text-align: center;margin-top: 30%;}
    .nolist img{width: 240ox;height: 120px;margin: 0 auto;display: block;}
    .nolist p{border-radius: 20px;color: #FFFFFF;display: flex;justify-content: center;align-items: center;background-image: linear-gradient(to right, #FF6738, #FF4F36);height: 34px;width: 60px;margin: 15px auto;}
    .list{margin: 0 12px auto;margin-top: 10px;}
    .list-item{background-color: #FFFFFF;border-radius: 12px;position: relative;}
    .list-item .title{padding: 12px 12px 0 12px;display: flex;align-items: center;}
    .list-item .title span:nth-of-type(1){padding: 3.33px 6.67px; height: 18px;border-radius: 12px;background-color: #17CF84;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 12px;}
    .list-item .title span:nth-of-type(2){color: #333333;font-size: 16px;font-weight: bold;padding-left: 6px;}
    .list-item .title span:nth-of-type(3){color: #333333;font-size: 16px;font-weight: bold;margin-left: 9.33px;}
    .list-item ul{padding: 0 12px 19.33px 12px; display: flex;justify-content: flex-start;align-items: center;flex-wrap: wrap;position: relative;}
    .list-item ul li{display: flex;flex-wrap: wrap;}
    .list-item ul li p{padding-top: 12px;}
    .list-item ul li .left{color: #999999;font-size: 14px;}
    .list-item ul li .right{padding-left: 15px;color: #999999;font-size: 14px;}

    @media screen and (max-width: 320px) {
        .list-item ul li .right{padding-left: 0px;}
    }

    .list-item ul li .left span{padding-left: 8.67px;color: #333333;font-size: 14px;}
    .list-item ul li .right span{padding-left: 8.67px;color: #333333;font-size: 14px;}

    /* 加载loading */
    .isloginTips{width: 150px;border-radius: 9px;background: rgba(0, 0, 0, 0.6);position: fixed;left: 0;right: 0;top: 40%;z-index: 888;color: #FFFFFF;font-weight: bold;font-size: 14px;text-align: center;line-height: 60px;margin: 0 auto;display: flex;justify-content: center;align-items: center;flex-direction: column;}
    .isloginTips p{height: 50px;display: flex;align-items: center;}
    .isloginTips img{width: 40px;height: 40px;display: block;margin-top: 20px;animation:loading 0.75s linear infinite forwards;}
    @keyframes loading {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    /*通过fixed固定mescroll的高度*/
	.mescroll {position: fixed;top: 112px;bottom: 0;height: auto;}

</style>


// WEBPACK FOOTER //
// src/components/shixiao.vue